// Module
var code = "<div id=\"content-error-overlay-container\" class=\"flex-center wrapper\">\n  <div class=\"flex-center icon-wrapper\">\n    <img id=\"content-error-overlay-img\" />\n    <div class=\"text-wrapper\">\n      <div id=\"content-error-overlay-message\"></div>\n    </div>\n  </div>\n</div>\n";
// Exports
export default code;